import React, { useEffect, useRef, useState } from "react";
import {
    CustomCheckboxTickIcon,
    CustomCommentIcon,
    CustomLayeredSquaresIcon,
    CustomSquareMinusIcon,
    TickerItemDiv,
    TickerName,
} from "./savedSettingsBlockStyles";
import { useAppSelector } from "hooks/redux";
import EditCommentModal from "components/modals/AddCommentModal";
import { Tooltip } from "antd";

export const TickerItem = ({
    groupName,
    tickerName,
    name,
    onClick,
    isTicker = false,
    isCurrentGroup = false,
    isSelected,
    onCheckboxClick,
    onDeleteClick,
    onCopyClick,
    isCurrent,
    onCommentClick,
}: // onSaveLogsClick
any) => {
    const editMode = useAppSelector((state) => state.settings.editMode);
    const showDescriptions = useAppSelector(
        (state) => state.settings.showDescriptions,
    );
    const [placement, setPlacement] = useState<"bottom" | "top">("bottom");
    const containerRef = useRef<HTMLDivElement>(null);
    const comment = tickerName?.comment || "";
    useEffect(() => {
        if (!comment || !showDescriptions || !containerRef.current) return;

        const updatePlacement = () => {
            const rect = containerRef.current!.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            setPlacement(spaceBelow < 80 ? "top" : "bottom");
        };

        updatePlacement();
        window.addEventListener("resize", updatePlacement);

        return () => window.removeEventListener("resize", updatePlacement);
    }, [comment, showDescriptions]);
    return (
        <TickerItemDiv id={`ticker-item-${name}`} isSelected={isSelected} ref={containerRef}>
            {showDescriptions && comment ? (
                <Tooltip
                    title={comment}
                    placement={placement}
                    overlayStyle={{ maxWidth: 280 }}
                    mouseEnterDelay={0.1}
                    mouseLeaveDelay={0.1}
                    overlayInnerStyle={{
                        borderRadius: 6,
                        padding: "6px 10px",
                        fontSize: "13px",
                    }}
                >
                    <TickerName onClick={onClick}>
                        {isCurrent && (
                            <span
                                style={{
                                    display: "inline-block",
                                    width: 6,
                                    height: 6,
                                    borderRadius: "50%",
                                    background: "#52c41a",
                                    marginRight: 8,
                                }}
                            />
                        )}
                        {name}
                    </TickerName>
                </Tooltip>
            ) : (
                <TickerName title={name} onClick={onClick}>
                    {isCurrent && (
                        <span
                            style={{
                                display: "inline-block",
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                background: "#52c41a",
                                marginRight: 8,
                            }}
                        />
                    )}
                    {name}
                </TickerName>
            )}

            {/*{isTicker && <CustomArrowsShrinkIcon onClick={onSaveLogsClick}/>}*/}
            {isTicker && editMode && (
                <CustomCommentIcon
                    $hasComment={!!comment}
                    title={comment || "Добавить комментарий"}
                    onClick={(e) => {
                        console.log("tickerName", tickerName);
                        e.stopPropagation();
                        onCommentClick?.(
                            tickerName || { ticker_name: name, comment: "" },
                        );
                    }}
                    style={{ cursor: "pointer" }}
                />
            )}
            {<CustomCheckboxTickIcon onClick={onCheckboxClick} />}
            <CustomLayeredSquaresIcon onClick={onCopyClick} />
            {!isCurrentGroup && (
                <CustomSquareMinusIcon onClick={onDeleteClick} />
            )}
        </TickerItemDiv>
    );
};
